import * as Sentry from '@sentry/browser';
import { notifyError } from '@rsos/utils/toastUtils';
import {
  AIR_AMBULANCE_CANCEL_ERROR_NOTIFICATION,
  AIR_AMBULANCE_CANCEL_FAILED_LOG,
} from './constants';

/**
 * handleCancelFailed notifies the user and logs the error when an air ambulance
 * cancellation attempt fails.
 * @param {string} logReason - Brief reason for the cancellation failure.
 * @param {object} logData - Data to be logged.
 * @returns {void}
 */
export const handleCancelFailed = (logReason, logData) => {
  Sentry.captureException(new Error(AIR_AMBULANCE_CANCEL_FAILED_LOG), {
    reason: logReason,
    ...logData,
  });

  notifyError(AIR_AMBULANCE_CANCEL_ERROR_NOTIFICATION);
};
